/* tslint:disable */

/**
 */
export class RpShiftDestroyForm {
    shift_id?: number;
    route_id?: number;
    work_time?: string;
    license_plates?: string;
    description?: string;
    total_pos?: number;
    total_charge?: number;
    total_deposit?: number;
}
